<template>
  <div
    v-if="modalIsOpened"
    id="teamInfoModal"
    class="fixed inset-0 w-full bg-black/30 z-51"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
      @click.self="closeModal"
    >
      <div class="w-[100vw] max-w-[495px] min-h-[690px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="h-full mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div
            class="flex flex-col justify-center items-start gap-[22px] pt-[12px] pr-[20px] pb-[20px] pl-[20px]"
          >
            <div class="w-full h-[92px] flex flex-col items-center">
              <TransferIcon class="min-w-[50px] min-h-[50px] text-[#9B237B]" />
              <span class="h-[24px] PC_Body1-SB text-[#1F1D1F]">
                โอนย้ายทรัพยากรระหว่างศูนย์
              </span>
              <div
                class="h-[18px] flex items-center gap-[6px] PC_caption-R text-[#1F1D1F]"
              >
                <span> โอนจาก </span>
                <span> : </span>
                <span> {{ shelterSelf }} </span>
              </div>
            </div>
            <div class="h-[472px] w-full flex flex-col items-start gap-[14px]">
              <div class="w-full">
                <SelectBox
                  :searchable="true"
                  label="โอนไปที่ ศูนย์พักพิง"
                  inputId="shelter_id"
                  valueKey="id"
                  :options="allTransferShelterList"
                  v-model="form.shelter_id"
                  :placeholder="'เลือกศูนย์พักพิง'"
                  @change="
                    (res) => {
                      form.shelter_id = res.id;
                    }
                  "
                />
              </div>
              <div class="w-full h-[384px]">
              <!-- pr-[16px] -->
                <div
                  class="w-full min-h-[600px] flex items-start gap-[14px] flex-wrap " 
                >
                <!-- {{ transfer }} -->
                <!-- product_request_id : {{ product_request_id }} -->
                  <div
                    v-for="(data, index) in transfer"
                    :key="index"
                    class="w-full min-h-[305px] flex flex-col gap-[10px] p-[14px] rounded-[8px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF]"
                  >
                    <SelectBox
                      :searchable="true"
                      label="ทรัพยากรที่ต้องการโอนย้าย"
                      :inputId="'product' + index"
                      valueKey="product_id"
                      :options="allTransferProductList"
                      v-model="data.product_id"
                      :placeholder="'เลือกทรัพยากร'"
                      @change="
                        (res) => {
                          data.product = res;
                          data.quantity = 0;
                          data.product_id = res.product_id || '';
                        }
                      "
                    />
                    <div
                      class="flex items-center justify-between p-[4px]"
                      :class="data.product_id == '' ? '' : 'bg-[#FBEFF8]'"
                    >
                      <div
                        class="flex items-center gap-[6px] PC_Body2-R"
                        :class="
                          data.product_id == ''
                            ? 'text-[#DFDCDD]'
                            : 'text-[#1F1D1F]'
                        "
                      >
                        <span> จำนวนคงเหลือ </span>
                        <span> : </span>
                        <span>

                          {{ $numberAndComma(data.product?.quantity) || "0" }}
                        </span>
                      </div>
                      <ButtonComponent
                        :label="'โอนทั้งหมด'"
                        :bClass="'btn_shadow--32 !max-w-[92px]'"
                        :disabled="
                          data.product_id == '' ||
                          data.quantity == data?.product?.quantity
                        "
                        @clicked="
                          () => {
                            data.quantity = data.maxValue;
                          }
                        "
                      />
                    </div>
                    <div class="flex flex-col gap-[12px]">
                      <div
                        class="PC_Body2-R"
                        :class="
                          data.product_id == ''
                            ? 'text-[#DFDCDD]'
                            : 'text-[#1F1D1F]'
                        "
                      >
                        ระบุจำนวนที่ต้องการโอนย้าย
                      </div>
                      <QuantitySelectorComponent
                        :inputClass="'!h-[42px] !min-w-[104px]'"
                        :disabled="data.product_id == ''"
                        :maxValue="data?.maxValue"
                        v-model:fieldValue="data.quantity"
                      />
                      <Input
                        label="หมายเหตุ (ถ้ามี)"
                        placeholder="หมายเหตุ (ถ้ามี)"
                        v-model="data.reason"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel'"
                @clicked="closeModal"
              />
              <ButtonComponent
                v-if="inShelter"
                :label="'ตกลง'"
                :bClass="'btn_shadow--save'"
                :disabled="!isValid"
                @clicked="save"
              />
              <ButtonComponent
                v-else
                :label="'ตกลง'"
                :bClass="'btn_shadow--save'"
                :disabled="
                  !isValid || form.shelter_id === '' || form.shelter_id === null
                "
                @clicked="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useProductStore } from "@/pinia/product";
import { storeToRefs } from "pinia";

const props = defineProps({
  inShelter: {
    type: Boolean,
    default: false,
  },
});

const productStore = useProductStore();
const { shelterSelf, allTransferShelterList, allTransferProductList } =
  storeToRefs(productStore);

const emit = defineEmits(["status", "open"]);

const input = {
  shelter_id: "",
  transfer: "",
};
const form = ref({ ...input });
const input2 = {
  product: [],
  // dataRaw:[],
  product_id: "",
  quantity: "0",
  reason: "",
  maxValue: "",
};
const transfer = ref([{ ...input2 }]);
const modalIsOpened = ref(false);

const product_request_id = ref(null)

const Options = computed(() => {
  return transfer.value
    .map((item) => item.product)
    .filter((id) => id !== "" && id != null);
});

const isValid = computed(
  () => !transfer.value.some((item) => item.quantity == "0" || !item.product_id)
);

const openModal = async (data, id, shelter_id) => {
  form.value.shelter_id = "";
  product_request_id.value = id
  transfer.value = [
    {
      ...input2,
    },
  ];

  await productStore.getProductShelterSelf();
  await productStore.getAllTransferProductList();

  if (data) {
    transfer.value[0].product = allTransferProductList.value.find(
      (item) => item.product_id == data.product_id
    );
    transfer.value[0].product_id = data.product_id;
    transfer.value[0].quantity = "0";
    transfer.value[0].maxValue = data.needed != "ไม่จำกัด" && Number(data.needed) < transfer.value[0].product.quantity ?  Number(data.needed) : transfer.value[0].product.quantity
  }
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";
  await productStore.getAllTransferShelterList();
  form.value.shelter_id = shelter_id;
  
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const save = async () => {
  const cleanedTransfer = transfer.value.map(({ maxValue, ...rest }) => rest);
  const body = {
    ...form.value,
    transfer: cleanedTransfer,
    product_request_id : product_request_id.value,
    spacial: 'true'
  };
  console.log(body);
  
  await productStore
    .createTransferProduct(body)
    .then((response) => {
      if (response.status === 200) {
        emit("status", response.data.message, "success");
        emit("open", response.data.data);
        closeModal();
      }
    })
    .catch((error) => {
      if (error.status === 400) {
        emit("status", error.response.data.message, "error");
      }
    });
};

const addResource = () => {
  transfer.value.push({ ...input2 });
};

const removeResource = (index) => {
  if (transfer.value[index]) {
    if (index === 0 && transfer.value.length == 1) {
      transfer.value[index] = {
        ...input2,
      };
    } else {
      transfer.value.splice(index, 1);
    }
  }
};

defineExpose({ openModal, closeModal });
</script>

<style lang="scss" scoped>
.title {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
.GButtonL {
  &:hover {
    .ButtonL {
      color: #9b237b !important;
    }
  }
}
.ButtonL {
  color: #1f1d1f;
  text-align: center;

  /* Button/L */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
</style>